var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconChevronUp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 11.941,
    viewBox: "0 0 22 11.941",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 11.941,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_chevron-up",
    "data-name": "Icon - chevron-up",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chevron-up",
    d: "M1.123,146.358l.349.349a.592.592,0,0,0,.837,0l9.641-9.641,9.641,9.641a.592.592,0,0,0,.837,0l.349-.349a.592.592,0,0,0,0-.837L12.368,135.113a.592.592,0,0,0-.837,0L1.123,145.521A.592.592,0,0,0,1.123,146.358Z",
    transform: "translate(-0.95 -134.939)",
    fill: "#b2b2b2"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconChevronUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon - chevron-up.adbe88cb4d39ab93e8089090c1b187f4.svg";